"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-teresa-gallura": {
    "501c6f44": [{
      "hkey": "9609212d",
      "slug": "santa-teresa-gallura",
      "name": "Santa Teresa Gallura",
      "primary": true,
      "skipSearch": false
    }],
    "isola-di-culuccia": [{
      "hkey": "9609212d",
      "slug": "santa-teresa-gallura",
      "name": "Santa Teresa Gallura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;